import merge from "lodash/merge";
import { theme as minervaTheme } from "./theme";
/**
 * @description A function that takes a custom theme and merges it with the base Minerva theme.
 * @param theme Must be a valid theme object
 */
export const createTheme = (theme, baseTheme = minervaTheme) => merge({}, baseTheme, theme);
//# sourceMappingURL=utils.js.map